import { Grid, Paper, Stack, Typography } from "@mui/material";
import _ from "lodash";
import TitleHeadSess from "../../../utils/TitleHeadSess";
import { useParams, useLocation } from "react-router-dom";
import moment from "moment";
import { useEffect, useState } from "react";
import { useApi } from "../../../utils/hooks";
import LoadingSpinner from "../../../utils/LoadingSpinner";
import formatGender from "../../../utils/formatGender";
import { ErrorAlert } from "../../../utils";
import NewMedicalDocumentButtons from "../../utils/medicalDocument/NewButtonsForPatient";
import MedicalDocumentsHistory from "./medicalDocumentsHistory";

const SectionContainer = ({ children }) => {
  return (
    <Paper
    variant="outlined"
    sx={{
      p: { xs: "20px 10px", sm: "20px 40px" },
      borderRadius: 3,
    }}>
      {children}
    </Paper>
  );
};

const DatailsPatient = () => {
  const location = useLocation();
  const { id } = useParams();
  const [failed, setFailed] = useState(false);
  const api = useApi();
  const [patient, setPatient] = useState({});
  const [loading, setLoading] = useState(true);
  const { path, patient: statePatient } = location.state || {
    path: undefined,
    patient: undefined,
  };
  const { name, surname, documentNumber, gender, birthDate, email, phone } =
    patient;

  useEffect(() => {
    if (!statePatient) {
      api
        .patientsDetails(id)
        .then((response) => {
          setPatient(response);
        })
        .tap(() => setLoading(false))
        .catch(() => {
          setLoading(false);
          setFailed(true);
        });
    } else {
      setLoading(false)
      setPatient(statePatient)
    }
  }, [statePatient]);

  const styleSubtittles = {
    fontWeight: 700,
    fontFamily: "Inter",
    color: "primary.main",
  };

  const styleTexts = {
    fontFamily: "Inter",
    color: "text.black",
    mt: 1,
  };

  if (loading && !patient)
    return <LoadingSpinner isLoading={loading} absolute />;

  if (failed && !loading)
    return (
      <ErrorAlert
        show={failed}
        onClose={() => setFailed(false)}
        message="El paciente no existe"
      />
    );

  if (!loading && patient) {
    return (
      <Stack
        spacing="1rem"
        sx={{
          p: { xs: "1rem", sm: "2rem" },
          mt: { xs: "1rem" },
          width: "100%",
          overflow: "auto",
        }}
      >
        <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" spacing={2}>
          <TitleHeadSess
            title={"Datos del Paciente | "}
            name={surname + ", " + name}
            urlRedirect={path ? path : "/patients"}
            iconTitle={"Volver"}
          />
          <Stack direction="row">
            <NewMedicalDocumentButtons patientId={id} />
          </Stack>
        </Stack>

        <SectionContainer>
          <Grid container spacing={{ xs: 2, sm: 6 }}>
            <Grid item xs={6} sm={4}>
              <Typography sx={styleSubtittles}>Apellido/s</Typography>
              <Typography sx={styleTexts}>{surname || "-"}</Typography>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Typography sx={styleSubtittles}>Nombre/s</Typography>
              <Typography sx={styleTexts}>{name || "-"}</Typography>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Typography sx={styleSubtittles}>N° de Documento</Typography>
              <Typography sx={styleTexts}>{documentNumber || "-"}</Typography>
            </Grid>
          
            <Grid item xs={6} sm={4}>
              <Typography sx={styleSubtittles}>Fecha de Nacimiento </Typography>
              <Typography sx={styleTexts}>
                {birthDate ? moment(birthDate).format("DD/MM/YYYY") : "-"}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Typography sx={styleSubtittles}>Género</Typography>
              <Typography sx={styleTexts}>
                {" "}
                {formatGender(gender) || "-"}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Typography sx={styleSubtittles}>Email</Typography>
              <Typography sx={styleTexts}> {email || "-"}</Typography>
            </Grid>
                    
            <Grid item xs={6} sm={4}>
              <Typography sx={styleSubtittles}>Telefono</Typography>
              <Typography sx={styleTexts}>{phone || "-"}</Typography>
            </Grid>
          </Grid>
        </SectionContainer>

        <MedicalDocumentsHistory patient={patient} />
      </Stack>
    );
  }
};

export default DatailsPatient;
